import {useQuery} from "@tanstack/react-query";
import {getList} from "../../../app/getters/getList.js";


export const useRaporty = (prefix = 'oper', enabled = true) => {
    return useQuery({
        queryKey: [`${prefix}_raporty`],
        queryFn: () => getList(`/${prefix}/raporty`),
        enabled: enabled,
    })
}